import DynamicFeedIcon from "@mui/icons-material/DynamicFeed";

import { resources as PublicProcurementActOrders } from "./PublicProcurementActOrders";
import { resources as PublicProcurementActProcedures } from "./PublicProcurementActProcedures";
import { resources as BuyerProfiles } from "./BuyerProfiles";

export const resources = {
  isMenu: true,
  name: "public-procurement-act",
  title: "ЗОП",
  icon: <DynamicFeedIcon />,
  permission: "publicProcurementAct",
  subMenu: [BuyerProfiles, PublicProcurementActProcedures, PublicProcurementActOrders],
};
